import React, { useEffect, useRef, useContext, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { slugify } from "../../../utils";
import { FontSizeContext } from "../../../context/fontSizeContext";
import { BiBorderRadius } from "react-icons/bi";

const BlogGrid = ({ data, classOption = "thumb" }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);

    return (
        <div className="blog-card">
            <div className={`thumb text-center ${classOption}`}>
                <img
                    src={`${process.env.PUBLIC_URL}${data.image}`}
                    alt=""
                    className="logo radius-box mb-3"
                    width={"20%"}
                    aria-hidden="true"
                />
            </div>
            <div className="blog-content text-center">
                {/* <h3 ref={(el) => (textRefs.current[2] = el)} className="title">
                    {data.title}
                </h3> */}
                <p
                    ref={(el) => (textRefs.current[2] = el)}
                    className="title"
                    style={{ fontFamily: "'Open Sans', sans-serif" }}
                >
                    {data.title}
                </p>
            </div>
        </div>
    );
};

BlogGrid.propTypes = {
    data: PropTypes.object,
    classOption: PropTypes.string,
};

export default BlogGrid;
